import React from 'react';
import { Box, Text, Absolute } from '@rsos/components/capstone/base';

const IPAddressManagementEmptyState = () => {
  return (
    <Absolute width="100%">
      <Box
        align="center"
        justify="center"
        height="430px"
        width="100%"
        color="secondaryText"
      >
        <Text size="normal" fontWeight="bold">
          Add a New IP Address
        </Text>
        <Text size="small">
          Please add a new IP address to manage access restriction.
        </Text>
      </Box>
    </Absolute>
  );
};

export default IPAddressManagementEmptyState;
